import { supabase } from './supabase.js';
import { TIPO_EVENTO } from './comunidadPublicaciones.js';

/**
 * @param {string} raw
 * @returns {boolean}
 */
export function isValidComunidadEntradaUrl(raw) {
  const s = String(raw ?? '').trim();
  if (!s) return true;
  try {
    const u = new URL(/^https?:\/\//i.test(s) ? s : `https://${s}`);
    return u.protocol === 'https:' && u.hostname.length > 0 && !u.hostname.includes('localhost');
  } catch {
    return false;
  }
}

/**
 * Invoca Edge `comunidad-verify-entrada` (autor o admin).
 * @param {string} publicationId
 * @param {{ force?: boolean }} [opts]
 */
export async function verifyComunidadEntradaPublication(publicationId, opts = {}) {
  const id = String(publicationId ?? '').trim();
  if (!id) return { ok: false, error: 'missing_id' };
  const { data, error } = await supabase.functions.invoke('comunidad-verify-entrada', {
    body: { publication_id: id, force: !!opts.force },
  });
  const serverMsg = data && typeof data === 'object' && data.message != null ? String(data.message) : '';
  if (error) {
    return { ok: false, error: serverMsg || error.message || 'No se pudo verificar el enlace.' };
  }
  if (!data?.ok && data?.error) {
    return { ok: false, error: serverMsg || data.error };
  }
  return {
    ok: true,
    verified: !!data?.verified,
    screening: data?.screening ?? null,
    alreadyVerified: !!data?.already_verified,
  };
}

/**
 * Tras guardar un evento con enlace de entradas, intenta verificación automática.
 * @param {string} publicationId
 * @param {{ tipo: string, entradaEnlace?: string }} form
 */
export async function tryAutoVerifyEntradaAfterSave(publicationId, form) {
  if (form?.tipo !== TIPO_EVENTO) return { ok: true, skipped: true };
  const link = String(form?.entradaEnlace ?? '').trim();
  if (!link) return { ok: true, skipped: true };
  if (!isValidComunidadEntradaUrl(link)) {
    return { ok: false, error: 'El enlace de entradas debe ser una URL https válida.' };
  }
  return verifyComunidadEntradaPublication(publicationId);
}
